
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.594 6.413v7.27s.07 1.682-1.758 1.796c-.747.046-1.295.192-1.681.36-1.08.417-1.835 1.368-1.835 2.467 0 1.48 1.336 2.49 3.06 2.49S21 20.162 21 17.99V1.99c0-.668-.555-1.1-1.239-.964L9.028 3.171c-.456.09-.755.507-.755.954v11.761s.07 1.683-1.757 1.797c-.747.046-1.295.192-1.681.36C3.755 18.46 3 19.41 3 20.51 3 21.99 4.336 23 6.06 23s3.62-.634 3.62-2.806V8.544l9.914-2.13z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    